import * as React from 'react';

const defaultClickAndReserveGlobalContextValues = {
    Form: undefined,
    confirmationNextSteps: undefined
};
const clickAndReserveGlobalContext = /*#__PURE__*/ React.createContext(defaultClickAndReserveGlobalContextValues);
const useClickAndReserveGlobalContext = ()=>{
    const context = React.useContext(clickAndReserveGlobalContext);
    if (context === defaultClickAndReserveGlobalContextValues) {
        throw new Error(`No ClickAndReserveGlobalProvider available. You might still
      need to wrap the application with the ClickAndReserve form context Provider.`);
    }
    return context;
};
const ClickAndReserveGlobalProvider = ({ Form , confirmationNextSteps , children ,  })=>{
    const { Provider  } = clickAndReserveGlobalContext;
    const value = React.useMemo(()=>({
            Form,
            confirmationNextSteps
        })
    , [
        Form,
        confirmationNextSteps
    ]);
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, children);
};
clickAndReserveGlobalContext.displayName = 'ClickAndReserveGlobalContext';
// @todo do I need a consumer?
clickAndReserveGlobalContext.Consumer;

export { ClickAndReserveGlobalProvider, clickAndReserveGlobalContext, useClickAndReserveGlobalContext };
//# sourceMappingURL=ClickAndReserveGlobalContext.js.map
